

import React, {useState} from 'react'
import FieldDropdown from '../FieldDropdown'
import DatabaseNonConformities from '../gestioneDatabase/DatabaseNonConformities'
import { exportExcel } from '../../lib/excel'
import { useCreateReplace, useDeleteDocument } from '../../hooks/mutations'
import { keyId, addValueForDropdown, copyId, errorAlert} from '../../lib/utils'
import VisDiv from '../frontend_components/VisDiv'
import { useStateContext } from '../../context/StateContext'
import { ManageDocumentReferenceInOtherDocuments, ReferenceCheckList, ReferencesArrayBox } from './ManagementModules'
import { StepByStepProgress } from './StepByStepProgress'
import {Divider, TextField, ViewLabelValueField} from '../../components'
import TrueFalseToggle from '../TrueFalseToggle'
import { richEditorDoc, referenceDoc } from '../gestioneDatabase/Docs'
import { v4 as uuidv4 } from 'uuid';
import RichTextEditor from '../RichTextEditor'
import {FiCopy } from 'react-icons/fi'
import { useQueryClient } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { _FETCH } from '../../lib/patches'
import { useAuthContext } from '../../hooks/useAuthContext'
import register from '../../sanity_ecommerce/schemas/register'

const DeviceTemplatesManagement = ({queryKey=['presidioModules'], data={}}) => {
  const {templateRegister, presidioModules, templateRegisters} = data
  const queryClient = useQueryClient()

const {mutate: updateRegisterTemplate} = useCreateReplace({
    onMutate: async (newDoc) => {

        await queryClient.cancelQueries({ queryKey: ['templateRegisters'] })
        const previousData = queryClient.getQueryData(['templateRegisters'])
   
        //const doc = newDoc?.doc
        
        queryClient.setQueryData(['templateRegisters'], (old) =>{ 
            const doc = newDoc?.doc
            const oldData = old?.length > 0 ? old : []
            const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
            return newData
        })
        return {previousData }
    },

    onError: (err, newDoc, context) => {
        console.error('Oh no, the update failed: ', err?.message)
        errorAlert("Errore: il documento non é stato aggiornato")
    }
    })

const {mutate: updateDocument} = useCreateReplace({
    onMutate: async (newDoc) => {

        await queryClient.cancelQueries({ queryKey: queryKey })
        const previousData = queryClient.getQueryData(queryKey)
   
        //const doc = newDoc?.doc
        
        queryClient.setQueryData(queryKey, (old) =>{ 
            const doc = newDoc?.doc
            const oldData = old?.length > 0 ? old : []
            const newData = [...oldData?.filter?.(x=>x?._id!== doc._id), doc]          
            return newData
        })
        return {previousData }
    },

    onError: (err, newDoc, context) => {
        console.error('Oh no, the update failed: ', err?.message)
        errorAlert("Errore: il documento non é stato aggiornato")
    }
    })


const {customer, newPresidioModule, setNewPresidioModule} = useStateContext()
//const [newNonConformity, setNewNonConformity] = useState()

const [presidioModuleFilter, setPresidioModuleFilter] = useState()
const [viewDatabaseList, setViewDatabaseList] = useState(false);

//const [selectedNonConf, setSelectedNonConf] = useState(undefined)
const [viewEmpty, setEmpty] = useState(false)


  const save = (data) => {
    setNewPresidioModule(data)
    updateDocument({doc: data})
    console.log("SAVE PRESIDIO DOC:", data)
}

  const templateRegistersReferenceData = {type: "referenceArray", hideFilter:true, data: templateRegisters, propertyName: "templates"}

  const progressList = [
    {description: "NOME PRESIDIO", component: <PresidioName doc={newPresidioModule} setDoc={save} data={{}}/>},
    {description: "ASSEGNA TIPOLOGIE REGISTRO", component: <AssignRegisterTemplates updateRegisterTemplate={updateRegisterTemplate} doc={newPresidioModule} setDoc={save} data={{referenceData: templateRegistersReferenceData}}/>},
    {description: "IMPOSTAZIONI", component: <ModulePresidioSettings doc={newPresidioModule} setDoc={save} />},
    {description: "ORDINE IN TEMPLATE", component: <TemplateOrder updateRegisterTemplate={updateRegisterTemplate} doc={newPresidioModule} setDoc={save} data={{templateRegisters, presidioModules}} />},
  ]

  const resetDoc = () => {
    setNewPresidioModule(undefined)
  }

   const testFunction = () => {
    console.log("TEST MANAGE MODULI PRESIDI", {newPresidioModule, templateRegisters})
   }

   return (
        <div style={{overflow:"auto", height:"100%", width:"100%"}}>
            <VisDiv rules={[true]}>
                <button onClick={testFunction}>TEST MANAGE MODULI PRESIDI</button>
            </VisDiv>
            <VisDiv rules={[newPresidioModule]}>
                <button onClick={resetDoc} className={"pdf-button"}>CHIUDI DOCUMENTO</button>
            </VisDiv>
            <VisDiv rules={[!newPresidioModule]}>
                <AddOrEditPresidioModule doc={newPresidioModule} setDoc={save} data={{...data, presidioModules}}/>
            </VisDiv>
            <VisDiv rules={[newPresidioModule]}>
                <StepByStepProgress progressList={progressList}/>
            </VisDiv>

        </div>
)


   
}

//=======================================================================================






export const AddOrEditPresidioModule = ({doc, setDoc, data={}}) => { 
    
  const {customer} = useStateContext()
  const [presidioName, setPresidioName] = useState("")
  const [selectedPresidioModule, setSelectedPresidioModule] = useState("")
  const {presidioModules, templateRegisters, deviceProperties, lists, dataModules, laws, products, suppliers, priceLists} = data 


  const duplicateDoc = () => ({
      ...selectedPresidioModule, 
      label: presidioName, 
      _id: uuidv4(), 
      _key: keyId(),
  })

  const emptyDoc = () => ({
      _type: "presidioModule",
      _id: uuidv4(),
      _key: keyId(),
      label: "",
      customer: referenceDoc(customer?._id),
      templates: [],
      templatesExclude: false,
      isConsole:false,
      oldRevisionYears: undefined,//number
      revisionYears: undefined,//number
      testYears: undefined,//number
      expiryYears: undefined,//number,
      annualTest: false,
      order: undefined,//number,
  })

  const labelValueDistance = 5

  const selectedProductData = [
      {label: "NOME", value: selectedPresidioModule?.label},
      {label: "REGISTRI", value: selectedPresidioModule?.templates?.map?.((item)=>!Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((x)=>x?._id == item?._ref)?.family)?.toString()},
      {highlight: "green", value: selectedPresidioModule?.templatesExclude && "ESCLUDE MODELLI REGISTRI"},
      {label: "ANNI SCADENZA", value: selectedPresidioModule?.expiryYears},
      {label: "ANNI TEST", value: selectedPresidioModule?.testYears},
      {highlight: "green", value: selectedPresidioModule?.annualTest && "TEST ANNUALE"},
      {label: "ANNI REVISIONE", value: selectedPresidioModule?.revisionYears},
      {label: "ANNI REVISIONE VECCHI", value: selectedPresidioModule?.oldRevisionYears},

      {highlight: "green", value: selectedPresidioModule?.isConsole && "CENTRALE IMPIANTO"},

  ]
  
  const createNewEmptyDoc = () => {
      if(presidioName){
          setDoc({...emptyDoc(), label: presidioName})
      } else {
          Swal.fire({
              position: 'top',
              icon: 'warning',
              title: "INSERIRE IL NOME DEL PRESIDIO",
              showConfirmButton: false,
              timer: 1500
            })
      }
  }
  const duplicateExistingDoc = () => {


     if(presidioName){
          setDoc(duplicateDoc())
          console.log("DUPLICATE DOC widhwdh", duplicateDoc())
      } else {
          Swal.fire({
              position: 'top',
              icon: 'warning',
              title: "INSERIRE IL NOME DEL PRODOTTO",
              showConfirmButton: false,
              timer: 1500
            })
      }
  }
  const editExistingDoc = () => {
      setDoc(selectedPresidioModule)
  }
  return (
  <div>
      <FieldDropdown
          sorted={true}
          isSearchable="isSearchable"
          //initialValue={expandSupplier(supplierProduct?.supplier)}
          placeHolder={"SELEZIONA PRESIDIO ESISTENTE"}
          options={addValueForDropdown(presidioModules)}
          onChange={(value) => { 
              setSelectedPresidioModule(value)
          }}
      />
      <TextField 
          value={presidioName} 
          label={"NOME NUOVO PRESIDIO"}
          onChange={(e) => setPresidioName(e.target.value)} 
          description={" Inserire un nome per creare un nuovo presidio o per duplicare una esistente."} 
          descriptionDivider={false}
      />
      <div style={{display:"flex", justifyContent:"space-evenly"}}>
          <VisDiv rules={[presidioName, !selectedPresidioModule]}>
              <button className="pdf-button" onClick={createNewEmptyDoc} >INSERISCI VUOTO</button>
          </VisDiv>
          <VisDiv rules={[selectedPresidioModule, !presidioName]}> 
              <button className="pdf-button" onClick={editExistingDoc} >MODIFICA PRESIDIO ESISTENTE</button>
          </VisDiv>
          <VisDiv rules={[selectedPresidioModule, presidioName]}>
              <button className="pdf-button" onClick={duplicateExistingDoc} >DUPLICA PRESIDIO </button>
          </VisDiv>
      </div>
      <VisDiv rules={[selectedPresidioModule]}>
          <Divider/>
          {selectedProductData?.map?.((item,index)=>{
              return(
                  <VisDiv key={index} rules={[item?.value]}>
                      <ViewLabelValueField 
                          label={item?.label} 
                          value={item?.value}
                          labelValueDistance={labelValueDistance}
                          highlight={item?.highlight}
                      />
                  </VisDiv>
              )
          })}

      </VisDiv>
  </div>
)}

export const PresidioName = ({doc, setDoc, data}) => { 
    
    return (
    <div>

        <TextField 
            value={doc?.label} 
            onChange={(e) => setDoc({...doc, label: e.target.value})} 
            description={"Questo dato non sarà inserito nell'offerta, serve per trovare la non conformità"} 
            descriptionDivider={false}
        />
        <div style={{display:"flex", marginTop:"10px", alignItems:"center"}}>
        <button type='button' className='round-back-button' style={{backgroundColor: "#324d67", marginRight:"10px"}} onClick={()=>copyId(doc)}>
                <FiCopy            
                size={15}
                color={"white"}/>
            </button>
            <h3>COPIA ID A CLIPBOARD</h3>

        </div>

    </div>
)}
//=======================================================================================

export const ModulePresidioSettings = ({doc, setDoc, data}) => { 

  const [oldRevisionYears, setOldRevisionYears] = useState(doc?.oldRevisionYears)
  const [revisionYears, setRevisionYears] = useState(doc?.revisionYears)
  const [testYears, setTestYears] = useState(doc?.testYears)
  const [expiryYears, setExpiryYears] = useState(doc?.expiryYears)
  const [order, setOrder] = useState(doc?.order)
  return (
  <div style={{marginTop:"10px"}}>
      <TrueFalseToggle 
          value={doc?.isConsole}
          onClick={()=>setDoc({...doc, isConsole: !doc?.isConsole})}
          label={"CENTRALE IMPIANTO"} 
          description={"Selezionare questa opzione se questo presidio è la centrale di un impianto."}
      />       
      <TextField 
        label={"ANNI DI REVISIONE"}
        description={"Quanti anni ha di revisione? Lasciare vuoto se non prevedete revisioni."}
        onBlur={()=> setDoc({...doc, revisionYears: (!Number(revisionYears) || revisionYears == 0) ? undefined : Number(revisionYears)})}
        style={{maxWidth: "400px",}}
        value={revisionYears} 
        onChange={(e) => {
            if(e.target.value == 0) setRevisionYears(undefined)
            else if(e.target.value == "") setRevisionYears(undefined)
            else if(!e.target.value) setRevisionYears(undefined)
            else setRevisionYears(e.target.value)
        }} 
        type={"number"}
      />
      <TextField 
          label={"ANNI DI REVISIONE VECCHIO"}
          description={"Quanti anni ha di vecchie revisioni? Questo campo è per gli estintori che sono stati creati prima del 2024. Lasciare vuoto se non prevedete vecchie revisioni."}
          onBlur={()=> setDoc({...doc, oldRevisionYears: (!Number(oldRevisionYears) || oldRevisionYears == 0) ? undefined : Number(oldRevisionYears)})}
          style={{maxWidth: "400px",}}
          value={oldRevisionYears} 
          onChange={(e) => {
              if(e.target.value == 0) setOldRevisionYears(undefined)
              else if(e.target.value == "") setOldRevisionYears(undefined)
              else if(!e.target.value) setOldRevisionYears(undefined)
              else setOldRevisionYears(e.target.value)
          }} 
          type={"number"}
      />
      <TextField 
        label={"ANNI DI COLLAUDO/TEST/TAGLIANDO"}
        description={"Quanti anni ha di collaudo/test/tagliando? Lasciare vuoto se non prevedete collaudi(test/revisioni)."}
        onBlur={()=> setDoc({...doc, testYears: (!Number(testYears) || testYears == 0) ? undefined : Number(testYears)})}
        style={{maxWidth: "400px",}}
        value={testYears} 
        onChange={(e) => {
            if(e.target.value == 0) setTestYears(undefined)
            else if(e.target.value == "") setTestYears(undefined)
            else if(!e.target.value) setTestYears(undefined)
            else setTestYears(e.target.value)
        }} 
        type={"number"}
      />
      <TrueFalseToggle 
          value={doc?.annualTest}
          onClick={()=>setDoc({...doc, annualTest: !doc?.annualTest})}
          label={"TEST / COLLAUDO ANNUALE"} 
          description={"Selezionare questa opzione se questo presidio richiede un test annuale, come per esempio per gli Idranti."}
      />       
      <TextField 
        label={"ANNI DI SCADENZA"}
        description={"Quanti anni ha di scadenza? Lasciare vuoto se non prevedete scadenza)."}
        onBlur={()=> setDoc({...doc, expiryYears: (!Number(expiryYears) || expiryYears == 0) ? undefined : Number(expiryYears)})}
        style={{maxWidth: "400px",}}
        value={expiryYears} 
        onChange={(e) => {
            if(e.target.value == 0) setExpiryYears(undefined)
            else if(e.target.value == "") setExpiryYears(undefined)
            else if(!e.target.value) setExpiryYears(undefined)
            else setExpiryYears(e.target.value)
        }} 
        type={"number"}
      />  
      <TextField 
        label={"ORDINE DELL OFFERTA"}
        description={"Inserire l'ordine in cui si vuole il presidio nell'offerta."}
        onBlur={()=> setDoc({...doc, order: (!Number(order) || order == 0) ? undefined : Number(order)})}
        style={{maxWidth: "400px",}}
        value={order} 
        onChange={(e) => {
            if(e.target.value == 0) setOrder(undefined)
            else if(e.target.value == "") setOrder(undefined)
            else if(!e.target.value) setOrder(undefined)
            else setOrder(e.target.value)
        }} 
        type={"number"}
      />  
  </div>
)}

//=======================================================================================

export const AssignRegisterTemplates = ({updateRegisterTemplate, doc, setDoc, data}) => { 

    const {referenceData} = data
    const saveTemplateRegister = (data) => {
        const presidioModuleReferenceDoc = referenceDoc(doc?._id)
        const templateRegister = data?.item
        if(!templateRegister) {
            errorAlert("Nessun modello trovato")
            return
        }
        if(data?.wasAdded){
           
            const wasAlreadyThere = templateRegister?.devices?.some((x)=>x?._ref == presidioModuleReferenceDoc?._ref)
            const newTemplateRegisterDoc = {
                ...templateRegister,
                devices: [...templateRegister?.devices, presidioModuleReferenceDoc]
            }
             console.log("òldkwefkewopfk was added", {data, wasAlreadyThere, newTemplateRegisterDoc})
             if(wasAlreadyThere) return
             updateRegisterTemplate({doc: newTemplateRegisterDoc}) 
        } else {
            const newTemplateRegisterDoc = {
                ...templateRegister,
                devices: [...templateRegister?.devices?.filter((x)=>x?._ref != presidioModuleReferenceDoc?._ref)]
            }
            console.log("lqmdlqwmdlkwm was removed", {data, newTemplateRegisterDoc})
            updateRegisterTemplate({doc: newTemplateRegisterDoc}) 
        }
    }

    return (
    <div>
        <TrueFalseToggle 
            value={doc?.templatesExclude}
            onClick={()=>setDoc({...doc, templatesExclude: !doc?.templatesExclude})}
            label={"ESCLUDI MODELLI REGISTRI"} 
            description={"Selezionare questa opzione se si vuole escludere i modelli selezionati invece di includerli. "}
        />
        <ReferenceCheckList dataCallback={saveTemplateRegister} doc={doc} setDoc={setDoc} referenceData={referenceData}/>
        
    </div>
    )
  
    
}
//=======================================================================================

export const TemplateOrder = ({updateRegisterTemplate, doc, setDoc, data}) => {
    const {templateRegisters, presidioModules} = data
    const assignedRegisterTemplates = !Array.isArray(doc?.templates) ? [] : doc?.templates?.filter?.((x)=>!x?.templatesExclude)
    const options = assignedRegisterTemplates?.map?.((x)=>{
        const findTemplate = !Array.isArray(templateRegisters) ? undefined : templateRegisters?.find?.((y)=>y?._id == x?._ref)
        if(!findTemplate?.devicesManualOrder) return
        return ({...findTemplate, label: findTemplate?.family, value: findTemplate?._id})
    }
    )?.filter(x=>x)
    const [selectedTemplate, setSelectedTemplate] = useState(null)
    const registerTemplateReferenceData = {type: "referenceArray", hideFilter:true, data: presidioModules, propertyName: "devices"}
    const saveTemplateRegister = (newDoc) => {
        console.log("jksdnsekjdfne", newDoc)
        setSelectedTemplate({...newDoc, label: newDoc?.family, value: newDoc?._id})
        updateRegisterTemplate({doc: newDoc})
    }
    return (
        <div>
            <VisDiv rules={[options?.length < 1]}>
                <div style={{textAlign:"center", color:"red", marginTop:"10px"}}>
                    <h4>NON CI SONO REGISTRI CON ORDINE MANUALE</h4>
                </div>
            </VisDiv>

            <VisDiv rules={[options?.length > 0]}>
                <FieldDropdown 
                    options={options}
                    placeHolder={"SELEZIONA UN REGISTRO"}
                    value={selectedTemplate}
                    onChange={(value) => setSelectedTemplate(value)}
                />
                <VisDiv rules={[selectedTemplate]}>
                    <ReferencesArrayBox 
                        hideDelete={true} 
                        hideAdd={true} 
                        hideEdit={true}
                        doc={selectedTemplate} setDoc={saveTemplateRegister} referenceData={registerTemplateReferenceData}/>
                </VisDiv>
                
            </VisDiv>
    </div>
    )
    
}
//=======================================================================================

const DeviceTemplatesManagementOLD = ({data={}}) => {

    const [viewEmpty, setEmpty] = useState(false)
    const {templateRegister, presidioModules} = data
    const emptyDevices = !Array.isArray(presidioModules) ? [] : presidioModules?.filter?.((x)=> !Array.isArray(x?.templates) ? false : x?.templates?.some?.(y=>!y?._ref)) 

    const registerFilteredDevices = !Array.isArray(presidioModules) ? [] : presidioModules?.filter?.((x)=> !Array.isArray(x?.templates) ? false : x?.templates?.some?.(y=>y?._ref == templateRegister?._id)) 
    //const registerFilteredDevices = presidioModules?.filter?.((x)=>x?.registers?.some?.(y=>y?._ref == templateRegister?._id)) 
  
    const devicesReferences = registerFilteredDevices?.map?.((item)=>({
        _ref: item._id,
        _type: "reference",
        _key: keyId()
    }))
    const arrayDevices = [];
    const DevicesPresenti = !templateRegister ? ( !Array.isArray(presidioModules) ? [] : presidioModules.filter?.(x=> !Array.isArray(arrayDevices) ? false : arrayDevices.some?.((y=>y==x.label)))) : (!Array.isArray(presidioModules) ? [] : presidioModules.filter?.(x=>!Array.isArray(arrayDevices) ? false : arrayDevices.some?.((y=>y==x.label))).filter?.(x=>x?.registers?.some?.(z=>z?._ref == templateRegister?._id)))



  const addDevicesToRegister = () => {

    if(!templateRegister) {console.log("ADD REGISTER")} 
    else {
      const doc = {
        ...templateRegister,
        devices: devicesReferences
      }
      console.log("add device to register", doc)
      updateDocument({doc: doc})
    }
  }
    
    const devicesListData = () => {
        if(!templateRegister && viewEmpty) {return emptyDevices}
        if(templateRegister) {return registerFilteredDevices}
        return presidioModules 
       }
    
       const devicesListExport = () => (
        devicesListData()?.map?.((item)=>{
          return(
            {
              label: item?.label,
              _id: item?._id,
              _type: item?._type,
              templates: item?.templates?.map?.(x=>x._ref).toString()
            }
          )
        })
       )

    const returnedDevices = (item, index) => 
        <div key={index} style={{borderRadius:"10px",border:"2px solid grey", padding:"10px", marginBottom:"5px"}}>
         <div onClick={()=>console.log(item)} style={{padding:"10px"}} >{item?.label}</div>
         
         <div style={{display:"flex"}}>
          <button className='red-button' onClick={()=>deleteDevice({documentId: item?._id })}>ELIMINA</button>
          <a className='red-button' style={{marginLeft:"5px", backgroundColor:"blue"}} target="_blank" href={`http://localhost:3333/desk/presidioModule;${item?._id}`} >MODIFICA</a>
          </div>
        </div>

    const devicesList = () => {
        if(!templateRegister && viewEmpty) {return emptyDevices?.map?.((item, index)=> returnedDevices(item,index))}
        if(templateRegister) {return registerFilteredDevices?.map?.((item, index)=> returnedDevices(item,index))}
        return presidioModules?.map?.((item, index)=> returnedDevices(item,index) )
       }


  return (
    <div>
      {/* <button style={{marginBottom:"10px", backgroundColor:"green"}}className='blue-button' onClick={addDevicesToRegister}>AGGIUNGI A REGISTRO</button>  */} 
      <button style={{marginBottom:"10px", backgroundColor:"green"}}className='blue-button' onClick={()=>exportExcel(devicesListExport(),"DATA EXPORT DEVICES")}>ESPORTA EXCEL</button>  

{/* <button style={{marginBottom:"10px", backgroundColor:"green"}}className='blue-button' onClick={addToList}>AGGIUNGI A LISTA</button>    */}   
{/*        <DatabaseNonConformities nonConformity={selectedNonConf} registerTemplate={templateRegister} allDeviceProperties={deviceProperties} presidioModules={presidioModules} />
*/}        {devicesList()}
    </div>
  )
}

export default DeviceTemplatesManagement
